import fallbackImage from '@public/images/fallback-image.png';

export const showFallbackImage = (
  e: React.SyntheticEvent<HTMLImageElement>,
  customDimensions: { width: number; height: number },
) => {
  const { currentTarget } = e;
  currentTarget.src = fallbackImage;
  currentTarget.width = customDimensions.width;
  currentTarget.height = customDimensions.height;
};
